var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c('pre',[_vm._v("  "+_vm._s(JSON.parse(_vm.config))+"\n")]):_c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"spinner"},[_c('scale-loader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }